exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "md-icon {\n  font-size: 150%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/UsersModule/UsersListComponent/users-list.component.scss
// module id = ../../../../../src/UsersModule/UsersListComponent/users-list.component.scss
// module chunks = main